module.exports = __webpack_public_path__ + "static/media/pokemol__brand--standard.f4d603d9.png";